/* global DialogHandleError, DialogHandleSuccess, noConnection */
$(document).on("click", "#submit_formulier_wachtwoord_opslaan", function() {
    const formulier = $(this).closest('form').attr('id');
    const parameters = $("form#" + formulier).serialize();

    $.post("views/user.wachtwoord.php", parameters, function(output) {
        if (output.search('ERROR') != -1) {
            DialogHandleError(output);
        } else {
            DialogHandleSuccess(output);
        }
    }).fail(function(_jqXHR, textStatus, errorThrown) {
        noConnection(textStatus, errorThrown);
    });
});
